module.exports = __webpack_public_path__ + "static/media/b1.4a9f3dd7.png";